/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GlobalVarsModel } from "../models/ModelGlobalsVar";
declare global {
  interface Window {
    GLOBALS: any;
  }
}
@Injectable({ providedIn: "root" })
export class NewBaseService {
  private GlobalVar$: BehaviorSubject<GlobalVarsModel> = new BehaviorSubject<GlobalVarsModel>(
    new GlobalVarsModel(window.GLOBALS),
  );

  //TODO: implement signals when migrate
  // private _globalsSignal = signal(new GlobalVarsModel(window.GLOBALS));

  constructor() {}

  // get globalsSignal() {
  //   return computed(() => this._globalsSignal());
  // }

  set setVar(vars: GlobalVarsModel) {
    this.GlobalVar$.next(vars);
    window.GLOBALS = vars;
    // this._globalsSignal.update(() => Object.create(vars));
  }

  get getVars() {
    return this.GlobalVar$.asObservable();
  }
}
